import React from 'react';
import PropTypes from 'prop-types';
import TextBody from '@lmig/dotcom-aspect-components/Utility/TextBody';
import { Heading } from '@lmig/lmds-react';
import { Maps } from './Google/DynamicExports';

const ArticleWithMap = ({
  title,
  headingTag = 'h4',
  headingType = 'h4',
  text,
  entityData = [],
  stateName
}) => {
  const markers = entityData.reduce((acc, val) => {
    if (val.location) {
      acc.push({
        name: `${val.address.city}, ${val.address.state.code}`,
        lat: val.location.coordinates[1],
        lng: val.location.coordinates[0],
        address: val.address,
        alias: val.aliasPath,
        phone: val.phones?.primary?.number,
      });
    }

    return acc;
  }, []);

  return (<>
    <div id="articleWithMap">
      <div className='articleSection'>
        {title && title !== ' ' &&
          <Heading tag={headingTag} type={headingType} >
            {title}
          </Heading>
        }
        {text && text !== ' ' && <TextBody >{text}</TextBody>}
      </div>
      <div className="mapWrapper">
        <Maps height="100%" markers={markers} stateName={stateName} />
      </div>
    </div>
    <style global jsx>{`@import './ArticleWithMap.scoped.scss';`}</style>
  </>);
};

ArticleWithMap.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  headingType: PropTypes.string,
  headingTag: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  entityData: PropTypes.array,
  stateName: PropTypes.string,
};

export default ArticleWithMap;